import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import RoundButton from '../../common/RoundButton';
import {
  CAMP_TRIBE_ACTIVITIES,
  PARTNER_EDIT_TREEHOUSE,
} from '../../../constants/routes.constants';
import CampAddDropdown from './CampAddDropdown';
import { useAuth } from '../../auth/Auth';
import { useRecoilState } from 'recoil';
import { stepsEnabledAtom } from '../../../atoms/camp.atom';

const CampActionButtons = ({ selectedTribe }) => {
  const history = useHistory();
  const { school } = useAuth();
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);

  const handleTribeActivity = () => {
    history.push({
      pathname: CAMP_TRIBE_ACTIVITIES,
      state: {
        tribe_id: selectedTribe?.id,
        tribe_name: selectedTribe?.name,
      },
    });
  };

  return (
    <div className="button-wrapper">
      {selectedTribe?.id === 0 || stepsEnabled ? (
        <>
          {school.user_type === 'school' && <CampAddDropdown />}
          {stepsEnabled && (
            <RoundButton
              type="button"
              label="Tribe Activities"
              className="edit-button button"
              onClick={handleTribeActivity}
              id="step-tribe-events"
            />
          )}
        </>
      ) : (
        <>
          {/* <RoundButton
            type="button"
            label="Open Notes"
            className="edit-button button"
          /> */}
          {school.user_type === 'school' && (
            <RoundButton
              type="button"
              label="Reassign Captain"
              className="edit-button button"
              onClick={() => history.push(PARTNER_EDIT_TREEHOUSE)}
            />
          )}
          <RoundButton
            type="button"
            label="Tribe Activities"
            className="edit-button button"
            onClick={handleTribeActivity}
          />
        </>
      )}
    </div>
  );
};

export default CampActionButtons;
